import * as tslib_1 from "tslib";
import { workflowCenterApi } from '@cloudpivot/api';
const state = {
    wd: '',
    asideTitle: '',
    asideTitleI18n: {},
    applicationPageTitle: '',
    unFinishedListCount: 0,
    unReadListCount: 0,
    userId: '',
    userData: {},
};
const mutations = {
    // 设置侧边栏title
    setAsideTitle(state, app) {
        if (!app || !app.name)
            return;
        state.asideTitle = app.name;
        state.asideTitleI18n = app.name_i18n;
    },
    // 设置应用中心页面title
    setApplicationPageTitle(state, title) {
        if (!title)
            return;
        state.applicationPageTitle = title;
    },
    // 设置待办待阅消息条数
    setListCoutnt(state, counts) {
        if (!counts)
            return;
        state.unFinishedListCount = counts.workItemCount;
        state.unReadListCount = counts.circulateItemCount;
    },
    // 设置用户id
    setUserId(state, data) {
        if (data.id) {
            state.userId = data.id;
            state.userData = data;
        }
    }
};
const actions = {
    // 获取待办待阅列表条数
    getWorkCount({ commit }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield workflowCenterApi.getWorkCount();
            if (res.errcode === 0) {
                commit('setListCoutnt', res.data);
            }
        });
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
